import React from 'react';
import { useStatusPalette } from '../utils/statusPalette';
import StatusChip from './StatusChip';

/**
 * Color legend for the talent×shift status taxonomy. Drop into any admin
 * view that needs to explain the chips. Grouped: Pre-Event / Live Event /
 * Post-Event / Declined.
 */
const StatusLegend = () => {
  const palette = useStatusPalette();
  if (!palette) return null;
  const { statuses, group_labels, group_order } = palette;
  const grouped = {};
  Object.values(statuses).forEach((s) => {
    (grouped[s.group] ||= []).push(s);
  });

  return (
    <div className="space-y-3" data-testid="status-legend">
      {group_order.map((g) => (
        <div key={g}>
          <div className="text-[11px] uppercase tracking-wider text-gray-500 font-medium mb-1.5">
            {group_labels[g] || g}
          </div>
          <div className="flex flex-wrap gap-1.5">
            {(grouped[g] || []).map((s) => (
              <StatusChip key={s.key} status={s.key} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatusLegend;
